import { Timeline as TimelineApp } from '@datapad/timeline';
import type React from 'react';

/**
 * Timeline app wrapper.
 *
 * @remarks
 * The Timeline app displays a chronological view of calendar events.
 * Events are retrieved via AppContext.getVisibleEvents(), which handles permission-based
 * filtering automatically. Sort state is managed internally by the Timeline component.
 */
export function Timeline(): React.ReactElement {
	return <TimelineApp />;
}
